var _templateObject, _templateObject2;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import { css, styled } from '@creditas-ui/system';
import { variant } from '@creditas-ui/utilities';
import { Box } from '@creditas-ui/layout';
var opacityToHex = opacityToken => {
  var numberToken = Math.round(parseFloat(opacityToken) * 100) / 100;
  var alpha = Math.round(numberToken * 255);
  var hex = (alpha + 0x10000).toString(16).substr(-2).toUpperCase();
  return hex;
};
var base = _ref => {
  var {
    theme: {
      progressIndicator
    }
  } = _ref;
  return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  content: '';\n  position: relative;\n  display: block;\n  box-sizing: border-box;\n  margin: ", ";\n  border-color: ", "", " ", "", "\n    ", "", " ", ";\n  border-width: ", ";\n  border-radius: ", ";\n  border-style: solid;\n  animation: spin ", " linear infinite;\n  @keyframes spin {\n    0% {\n      transform: rotate(0deg);\n    }\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n\n  span {\n    border: 0;\n    clip: rect(0 0 0 0);\n    height: 1px;\n    margin: -1px;\n    overflow: hidden;\n    padding: 0;\n    position: absolute;\n    width: 1px;\n  }\n"])), progressIndicator('spinner.spacing'), progressIndicator('spinner.baseBorderColor'), opacityToHex(progressIndicator('spinner.baseOpacity')), progressIndicator('spinner.baseBorderColor'), opacityToHex(progressIndicator('spinner.baseOpacity')), progressIndicator('spinner.baseBorderColor'), opacityToHex(progressIndicator('spinner.baseOpacity')), progressIndicator('spinner.progressBorderColor'), progressIndicator('spinner.strokeWidth'), progressIndicator('spinner.borderRadius'), progressIndicator('spinner.motion'));
};
var sizes = variant({
  prop: 'size',
  variants: {
    xsmall: {
      width: '12px',
      height: '12px'
    },
    small: {
      width: '20px',
      height: '20px'
    },
    medium: {
      width: '28px',
      height: '28px'
    },
    large: {
      width: '40px',
      height: '40px'
    }
  }
});
export var SpinnerIndeterminateElement = styled(Box.withComponent('span', process.env.NODE_ENV === "production" ? {
  target: "e1phuxed0"
} : {
  target: "e1phuxed0",
  label: "SpinnerIndeterminateElement"
}))(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n"])), base, sizes);
//# sourceMappingURL=Spinner.style.js.map